import { createFileRoute } from '@tanstack/react-router'
import { AISettingsFeature } from '@/features/organizations/settings/ai-settings'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/ai-settings'
)({
  component: AISettingsFeature,
})


